/* eslint-disable react/prop-types */
import { Grid, MenuItem, Select } from '@mui/material';
import SoftBox from 'components/SoftBox';
import React, { useEffect, useState } from 'react'
import renderInputField from 'utils/renderInputField';
import Loading from 'components/Loading';
import { toast } from 'react-toastify';
import SoftTypography from 'components/SoftTypography';
import { getBadgeCategory } from 'services/badge.routes';
import SoftButton from 'components/SoftButton';

export default function Fields({ method, information, setInformation, handleUpdate, submit }) {
    const handleChange = (event) => {
        const { name, value } = event.target;
        setInformation({ ...information, [name]: value });
    };
    const handleImageChange = (event) => {
        const { name, files } = event.target;
        setInformation({ ...information, [name]: files });
    };
    const [loading, setLoading] = useState(false);
    const [badgeCategory, setBadgeCategory] = useState([])
    useEffect(() => {
        setLoading(true);
        getBadgeCategory((isOk, data) => {
            setLoading(false);
            if (!isOk) {
                return toast.error(data.message);
            } else {
                setBadgeCategory(data);
            }
        });
    }, [])

    return (
        <SoftBox py={3}>
            <Loading loading={loading} />
            <SoftBox component="form" role="form">
                <Grid container spacing={3}>
                    {renderInputField("name", "نام", "text", "نام", information, handleChange)}
                    {[{
                        label: "دسته بندی", name: "category_id", options: badgeCategory.map(item => ({ value: item.id, label: item.name }))
                    }].map((selectField, index) => (
                        <Grid item xs={12} sm={6} xl={3} key={index}>
                            <SoftBox mb={1} ml={0.5}>
                                <SoftTypography component="label" variant="caption" fontWeight="bold">
                                    {selectField.label}
                                </SoftTypography>
                            </SoftBox>
                            <Select name={selectField.name} value={String(information[selectField.name])} onChange={handleChange} fullWidth>
                                {selectField.options.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    ))}
                    <Grid item xs={12} sm={6} xl={3}>
                        <SoftBox mb={1} ml={0.5}>
                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                                آیکون
                            </SoftTypography>
                        </SoftBox>
                        <input
                            name="icon"
                            onChange={handleImageChange}
                            type="file"
                            style={{
                                background: 'white',
                                padding: '8px 12px',
                                width: '100%',
                                border: '0.0625rem solid #d2d6da',
                                borderRadius: '0.5rem',
                                color: '#495057'
                            }}
                            placeholder="Images"
                            accept=".jpg,.jpeg,.png"
                        />
                    </Grid>
                </Grid>
                <SoftButton
                    onClick={method !== "update" ? submit : handleUpdate}
                    style={{ marginTop: 40 }}
                    variant="gradient"
                    color="info"
                >
                    {method !== "update" ? "ثبت" : "آپدیت"}
                </SoftButton>
            </SoftBox>
        </SoftBox>
    )
}
